(function () {
    'use strict';

    angular
        .module('services.pageDirty', [])
        .factory('pageDirtyService', service);

    service.$inject =
                   ['$rootScope', '$modal'];
    function service($rootScope,   $modal) {
        var _isInit = false,
            _isDirty = false,
            _skipCheckDirty = false,
            _dirtyCount = 0,
            _modalScope = $rootScope.$new(),
            _modalObject;

        _modalScope.model = {};


        function init() {
            // Init modal
            _modalObject = $modal({
                scope: _modalScope,
                show: false,
                template: '/app/shared/components/services/pageDirtyDialog.tpl.html',
                placement: 'center'
            });

            _modalScope.hideModal = function () {
                _modalObject.$promise.then(_modalObject.hide);
            };

            _modalScope.showModal = function () {
                _modalObject.$promise.then(_modalObject.show);
            };

            _modalScope.ok = function () {
                _modalScope.hideModal();
            };

            // Register state change start event
            $rootScope.$on('$stateChangeStart', function (event) {
                if (!_skipCheckDirty && _isDirty) {
                    // Prevent navigating and show dialog
                    event.preventDefault();

                    _modalScope.showModal();
                } else {
                    _skipCheckDirty = false;
                    _modalScope.message = null;
                }
            });

            _isInit = true;
        }

        init();

        return {
            /**
             * Sets the page as dirty to prevent navigation.
             * @param {string} message - if provided, message displayed in the body of the modal when navigating away
             */
            setPageDirty: function (message) {
                _isDirty = true;
                ++ _dirtyCount;

                if (_.isString(message)) {
                    _modalScope.model.message = message;
                }
            },

            /**
             * When called, confirm dialog will not be displayed upon navigation
             */
            setPageNotDirty: function () {
                -- _dirtyCount;
                //console.log('undirty ' + _dirtyCount)
                if (_dirtyCount < 1) {
                    _isDirty = false;
                    _dirtyCount = 0;
                }
            },

            /**
             * @returns {boolean} - true if page is marked as dirty
             */
            isPageDirty: function () {
                return _isDirty
            },

            /**
             * Displays the dialog if the page is marked as dirty.
             * This is used when manually preventing user to navigate if page is dirty.
             * @returns {boolean} - true if the page is dirty (dialog is displayed)
             */
            showDialog: function () {
                var dirty = !_skipCheckDirty && _isDirty;
                if (dirty) {
                    _modalScope.showModal();
                }
                return dirty;
            },

            /**
             * Defines if the we should check for page dirty
             * @param {boolean} [isSkip = true] - true to skip check, false otherwise, defaults to true
             */
            skipCheckForDirty: function (isSkip) {
                _skipCheckDirty = (_.isBoolean(isSkip) ? isSkip : true);
            }
        };
    }
})();